import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PropertiesService } from 'src/app/properties/service/properties.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-sale-and-rent',
  templateUrl: 'sale-and-rent.component.html',
  styleUrls: ['./sale-and-rent.component.scss']
})
export class SaleAndRentComponent implements OnInit {

  @Input() forms: FormGroup;

  public formSubscription: Subscription;

  constructor(private formBuilder: FormBuilder,
              private service: PropertiesService) { }

  ngOnInit(): void {
    this.formInit();
  }

  formInit(): void {
    if (!this.forms) {
      this.forms = this.formBuilder.group({
        sale: [ false ],
        salePrice: [ null, [ Validators.required ] ],
        commission: [ null ],
        settled: [ true ],
        notSettled: [ null ],
        debt: [ null ],
        profitable: [ false ],
        notProfitable: [ true ],
        income: [ null ],
        saleD1: [ false ],
        saleD2: [ false ],
        saleD3: [ false ],
        saleD4: [ false ],
        saleResponsible: [ null ],
        rent: [ false ],
        rentPrice: [ null, [ Validators.required ] ],
        rentD1: [ null ],
        rentD2: [ null ],
        rentD3: [ null ],
        rentResponsible: [ null ]
      });
    }
    this.forms.get('debt').disable();
    this.forms.get('income').disable();
  }

  public toggleForm(ev: boolean, control: string): void {
    this.forms.get(control).patchValue(ev);
  }

  public toggleDebt(ev: boolean): void {
    this.forms.get('settled').patchValue(ev);
    this.forms.get('notSettled').patchValue(!ev);
    if (ev) {
      this.forms.get('debt').disable();
      return;
    }
    this.forms.get('debt').enable();
  }

  public toggleIncome(ev: boolean): void {
    this.forms.get('profitable').patchValue(ev);
    this.forms.get('notProfitable').patchValue(!ev);
    if (ev) {
      this.forms.get('income').enable();
      return;
    }
    this.forms.get('income').disable();
  }

}
